/*
 * Silences the sound on the header's 6 primary nav tabs (Home, Manifest,
 * The Import, Oscar4Fox, Archives, Case Files) at the merchant's request —
 * the multi-partial FM bell/mallet tone siteTone() plays (sub-octave body,
 * shimmer partial, half-second decay) reads as "chunky" for something
 * clicked this often. Every other sound in the header — the crate, the
 * wishlist, mute toggle, sign in, account menu, request clearance — is
 * untouched; this only mutes the 6 page-switching links themselves.
 *
 * Implemented by wrapping the handlers renderVals already returns rather
 * than editing sat-app.js's goHome/goManifest/etc. directly: each of those
 * mixes navigation (setState + scrollTo) with its sound call in one
 * function, so there's no separate "just the sound" hook to unset —
 * wrapping and re-calling setState/scrollTo ourselves, sound call
 * omitted, is the smallest change that doesn't touch the shared asset.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var QUIET_KEYS = ['goHome', 'goManifest', 'goStore', 'goArchives', 'goCasefiles', 'openOscar4Fox'];

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;

    QUIET_KEYS.forEach(function (key) {
      var original = out[key];
      if (typeof original !== 'function') return;
      out[key] = function (e) {
        // Sound calls all go through this AudioContext-backed method — swap it
        // out for a no-op for the length of the original call, then restore it,
        // rather than trying to guess which of setState/scrollTo/sound calls
        // inside `original` is the sound.
        var savedTone = self.siteTone, savedClick = self.siteClick, savedThunk = self.thunk;
        self.siteTone = function () {};
        self.siteClick = function () {};
        self.thunk = function () {};
        try { original(e); }
        finally { self.siteTone = savedTone; self.siteClick = savedClick; self.thunk = savedThunk; }
      };
    });

    return out;
  };
})();
